var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observer } from 'mobx-vue';
import { Component, Vue } from 'vue-property-decorator';
import Error from './error.vue';
import ViewToken from './views/token.vue';
import ViewVersion from './views/version.vue';
let default_1 = class extends Vue {
    constructor() {
        super(...arguments);
        this.keepAliveProps = {
        // include: [
        // ],
        // exclude: [
        // ],
        };
    }
    get System() {
        return this.$Store.System;
    }
    get keepAlive() {
        // 开启
        return this.AppConfig.production;
    }
    mounted() { }
    updated() { }
    destroyed() { }
};
default_1 = __decorate([
    observer,
    Component({
        components: { Error, ViewToken, ViewVersion },
    })
], default_1);
export default default_1;
